import script from "./explain.vue?vue&type=script&setup=true&lang=js"
export * from "./explain.vue?vue&type=script&setup=true&lang=js"

import "./explain.vue?vue&type=style&index=0&id=e245adee&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e245adee"]])

export default __exports__